import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import JobsPage from '../components/Jobs/JobsPage';
import JobDetailPage from '../components/Jobs/JobDetailPage';
import CreateJobPage from '../components/Jobs/CreateJobPage';
import MyActivityPage from '../components/MyActivity/MyActivityPage';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/jobs" replace />} />
      <Route path="/jobs" element={<JobsPage />} />
      <Route path="/jobs/new" element={<CreateJobPage />} />
      <Route path="/jobs/:id" element={<JobDetailPage />} />
      <Route path="/my-activity" element={<MyActivityPage />} />
    </Routes>
  );
}

export default AppRoutes;
